import type { Item } from "../api/types";
import { dueMoment } from "./format";
import { todayYmd, zonedToDate } from "./tz";

export type DueBucket = "overdue" | "today" | "upcoming" | "none";

/** My-tasks grouping. Date-only dues resolve to the end of their day, so "today" is never overdue. */
export function bucketOfDue(item: Pick<Item, "due_at" | "due_has_time">, now = new Date()): DueBucket {
  const due = dueMoment(item);
  if (!due) return "none";
  const endOfToday = zonedToDate(todayYmd(now), "23:59").getTime() + 59999;
  if (due.getTime() < now.getTime()) return "overdue";
  if (due.getTime() <= endOfToday) return "today";
  return "upcoming";
}
